import { render } from "./StargazerTent.vue?vue&type=template&id=3c6f94fb&scoped=true"
import script from "./StargazerTent.vue?vue&type=script&lang=js"
export * from "./StargazerTent.vue?vue&type=script&lang=js"

import "./StargazerTent.vue?vue&type=style&index=0&id=3c6f94fb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6f94fb"]])

export default __exports__